import React from 'react';
import { Table } from 'antd';
import styles from './RejectsTable.module.css';
import { withTestColumnAttrs, type TestAttrs } from '@utils/testAttr';

interface RejectRecord {
    meterNumber: string;
    reasonToReject: string;
}

interface RejectsTableProps {
    rejects: RejectRecord[];
}

const RejectsTable: React.FC<RejectsTableProps> = ({ rejects }) => {
    const columns = [

        {
            title: 'Meter Number',
            dataIndex: 'meterNumber',
            key: 'meterNumber',
            width: 200,

        },
        {
            title: 'Reject Reason',
            dataIndex: 'reasonToReject',
            key: 'reasonToReject',
            render: (reason: string) => (
                <span className={styles.rejectReason}>{reason}</span>
            ),
        },
    ];

    return (
        <div className={styles.rejectsContainer} data-testid="rejects-section" data-reject-count={rejects.length}>
            <div className={styles.rejectsHeader}>
                <span className={styles.warningIcon}>⚠️</span>
                <h4 className={styles.rejectsTitle} data-testid="rejects-title">
                    Rejected Records ({rejects.length})
                </h4>
            </div>
            <Table
                columns={withTestColumnAttrs<RejectRecord>(columns, 'reject-value')}
                dataSource={rejects}
                rowKey={(record, index) => `${record.meterNumber}-${index}`}
                pagination={false}
                size="small"
                className={styles.rejectsTable}
                data-testid="rejects-table"
                onRow={(record) => ({ 'data-testid': 'reject-row', 'data-meter-number': record.meterNumber }) as TestAttrs}
            />
        </div>
    );
};

export default RejectsTable;